export const environment = {
  production: true,
  apiUrl: "https://umyotruckers.site/api_umyocards/public/api/"
};


